// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-wbdStudentMng-index-main_right_content-2pLnV","table":"components-wbdStudentMng-index-table-Dx3Rj"};


//////////////////
// WEBPACK FOOTER
// ./components/wbdStudentMng/index.css
// module id = 2326
// module chunks = 0